import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Report } from './reportsStore';

// Define the structure for stored comparison items
export interface CompareItem {
  id: string; // Unique instance ID (e.g., slug-index)
  report: Report;
}

export const useCompareStore = defineStore('compare', () => {
  // Store an array of CompareItem objects
  const selectedReports = ref<CompareItem[]>([]);

  // Add report by instance ID and report data
  function addReport(instanceId: string, reportData: Report) {
    // Check limit and uniqueness based on instanceId
    if (selectedReports.value.length < 3 && !selectedReports.value.some(item => item.id === instanceId)) {
      selectedReports.value.push({ id: instanceId, report: reportData });
    }
  }

  // Remove report by instance ID
  function removeReport(instanceId: string) {
    const initialLength = selectedReports.value.length;
    selectedReports.value = selectedReports.value.filter(item => item.id !== instanceId);
  }

  function clearReports() {
    selectedReports.value = [];
  }

  return {
    selectedReports,
    addReport,
    removeReport,
    clearReports
  };
}); 